module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26271",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6678",
      "conversations-error-reporting": "static-1.7950",
      "conversations-internal-pub-sub": "static-1.15032",
      "conversations-internal-schema": "static-1.11658",
      "conversations-message-history": "static-1.10136",
      "conversations-test-sdk": "static-1.9491",
      "conversations-visitor-experience-components": "static-1.19634",
      "head-dlb": "static-1.4195",
      "hs-promise-utils": "static-1.4558",
      "hs-test-utils": "static-1.7024",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10546",
      "I18n": "static-7.1403",
      "jasmine-immutable": "static-1.1995",
      "jasmine-runner": "static-1.5450",
      "quartz": "static-1.5782",
      "react-aria": "static-1.40",
      "react-dlb": "static-1.55",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3570",
      "viral-links-lib": "static-1.5902",
      "visitor-ui-component-library": "static-1.5217",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3599",
      "atom": "static-1.4180",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3822",
      "conversations-infrastructure": "static-1.7965",
      "conversations-prop-types": "static-1.6479",
      "conversations-visibility-tools": "static-1.4803",
      "conversations-visitor-message-history": "static-1.18371",
      "cssUtils": "static-1.536",
      "enviro": "static-4.312",
      "flux-actions": "static-1.279",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.290",
      "raven": "static-3.5020",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15590",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4503",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3407",
      "sanitize-text": "static-1.7181",
      "signup-constants": "static-1.16770",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.467",
      "usage-tracker": "static-1.6493",
      "usage-tracker-core": "static-1.6343",
      "usage-tracker-multi": "static-1.4907",
      "usage-tracker-public": "static-1.6304",
      "visitor-ui-component-library-icons": "static-1.5028",
      "hs-promise-rejection-tracking": "static-1.4552",
      "raven-hubspot": "static-1.5327",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2639",
      "moment": "static-3.26",
      "quartz-core": "static-1.5001",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3930",
      "foundations-components": "static-1.6300",
      "foundations-theming": "static-1.3334",
      "UIComponents": "static-3.7493",
      "cv-backend-services": "static-1.1243",
      "immutable-less": "static-1.3589",
      "conversations-skeleton-state": "static-1.6394",
      "icons": "static-2.592",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.3766",
      "ui-images": "static-2.896",
      "permission-components": "static-1.4407",
      "react-virtualized": "static-2.75",
      "HeadJS": "static-2.586",
      "framer-motion": "static-1.42",
      "hs-test-utils-bend-plugin": "static-1.2135",
      "msw": "static-1.39",
      "testing-library": "static-1.124",
      "i18n-data": "static-1.199",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3379",
      "quartz-core-utils": "static-1.2649",
      "signup-ui-url-generator": "static-2.7085",
      "HubStyle": "static-2.10854",
      "sassPrefix": "static-1.133",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4910",
      "copilot-toolkit": "static-1.7522",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.659",
      "hub-http-shared-msw-handlers": "static-1.7349",
      "hubspotter-http": "static-1.3768",
      "hubspotter-http-shared-msw-handlers": "static-1.7347",
      "mobile-manifest-mixins": "static-1.357",
      "platform-navigation-bootstrap": "static-1.11451",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "hs-story-utils": "static-1.8394",
      "bend-plugin-foundations-components": "static-1.2569",
      "floating-ui": "static-1.30",
      "foundations-theming-specialty": "static-1.1051",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1817",
      "foundations-theming-base": "static-1.2319",
      "ts-schema": "static-1.3294",
      "chatspot-client-types": "static-1.9059",
      "chatspot-core": "static-1.16902",
      "platform-infra-nav-components": "static-1.6880"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26271",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6678",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7950",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15032",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11658",
      "conversations-message-history": "/conversations-message-history/static-1.10136",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9491",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19634",
      "head-dlb": "/head-dlb/static-1.4195",
      "hs-promise-utils": "/hs-promise-utils/static-1.4558",
      "hs-test-utils": "/hs-test-utils/static-1.7024",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10546",
      "I18n": "/I18n/static-7.1403",
      "jasmine-immutable": "/jasmine-immutable/static-1.1995",
      "jasmine-runner": "/jasmine-runner/static-1.5450",
      "quartz": "/quartz/static-1.5782",
      "react-aria": "/react-aria/static-1.40",
      "react-dlb": "/react-dlb/static-1.55",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3570",
      "viral-links-lib": "/viral-links-lib/static-1.5902",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5217",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3599",
      "atom": "/atom/static-1.4180",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3822",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7965",
      "conversations-prop-types": "/conversations-prop-types/static-1.6479",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4803",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18371",
      "cssUtils": "/cssUtils/static-1.536",
      "enviro": "/enviro/static-4.312",
      "flux-actions": "/flux-actions/static-1.279",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.290",
      "raven": "/raven/static-3.5020",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15590",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4503",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3407",
      "sanitize-text": "/sanitize-text/static-1.7181",
      "signup-constants": "/signup-constants/static-1.16770",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.467",
      "usage-tracker": "/usage-tracker/static-1.6493",
      "usage-tracker-core": "/usage-tracker-core/static-1.6343",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4907",
      "usage-tracker-public": "/usage-tracker-public/static-1.6304",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5028",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4552",
      "raven-hubspot": "/raven-hubspot/static-1.5327",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2639",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5001",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3930",
      "foundations-components": "/foundations-components/static-1.6300",
      "foundations-theming": "/foundations-theming/static-1.3334",
      "UIComponents": "/UIComponents/static-3.7493",
      "cv-backend-services": "/cv-backend-services/static-1.1243",
      "immutable-less": "/immutable-less/static-1.3589",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6394",
      "icons": "/icons/static-2.592",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.3766",
      "ui-images": "/ui-images/static-2.896",
      "permission-components": "/permission-components/static-1.4407",
      "react-virtualized": "/react-virtualized/static-2.75",
      "HeadJS": "/HeadJS/static-2.586",
      "framer-motion": "/framer-motion/static-1.42",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2135",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.124",
      "i18n-data": "/i18n-data/static-1.199",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3379",
      "quartz-core-utils": "/quartz-core-utils/static-1.2649",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7085",
      "HubStyle": "/HubStyle/static-2.10854",
      "sassPrefix": "/sassPrefix/static-1.133",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4910",
      "copilot-toolkit": "/copilot-toolkit/static-1.7522",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.659",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7349",
      "hubspotter-http": "/hubspotter-http/static-1.3768",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7347",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.357",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11451",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "hs-story-utils": "/hs-story-utils/static-1.8394",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2569",
      "floating-ui": "/floating-ui/static-1.30",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1051",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1817",
      "foundations-theming-base": "/foundations-theming-base/static-1.2319",
      "ts-schema": "/ts-schema/static-1.3294",
      "chatspot-client-types": "/chatspot-client-types/static-1.9059",
      "chatspot-core": "/chatspot-core/static-1.16902",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6880"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};